import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections, TwoSelectionsProps } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { InputTemplate, InputTemplateProps } from 'views/templates/module/inputTemplate';

export const NationalityQuestionTop = () => {
  return (
    <>
      <div className="nationalityQuestionTop">
        <CardLabel
          letter="&#10102; お客様の国籍を選択してください"
          sentence="恐れ入りますが国籍が日本以外の方は、口座開設をお受けできません。取引を希望される場合は最寄りの営業拠点にお問い合わせください。"
        />
      </div>
    </>
  );
};

interface NationalityQuestionBottomProps {
  selection: TwoSelectionsProps;
  input: InputTemplateProps;
}

export const NationalityQuestionBottom = ({ selection, input }: NationalityQuestionBottomProps) => {
  return (
    <div className={`nationalityQuestionBottom`}>
        <TwoSelections {...selection} />
      </div>
  );
};
